import React, { useEffect, useRef, useState } from "react";
import "./LeaderBoard.css";
import giantsquid from "../../assets/images/Giant Squid.svg";
import squid from "../../assets/images/Collosal Squid.svg";
import ostrich from "../../assets/images/Ostrich 3.svg";
import horse from "../../assets/images/Horse 1.svg";
import dog from "../../assets/images/Dog.svg";
import cat from "../../assets/images/Cat 3.svg";
import fish from "../../assets/images/Gold fish 2.svg";
import ant from "../../assets/images/Ant 3.svg";
import housefly from "../../assets/images/House fly 3.svg";
import fruitfly from "../../assets/images/House fly 4.svg";
import leftArrow from "../../assets/images/leftarrowBoard.png";
import rightArrow from "../../assets/images/rightarrowBoard.png";
import useUserInfo from "../../Hooks/useUserInfo";
import ProgressBar from "react-bootstrap/esm/ProgressBar";
import youtube from "../../assets/images/youtube.svg";
import logo from "../../assets/images/meme-logo.svg";
import cancelIcon from "../../../src/assets/Task/cancelicon.svg";
import { getPopularUser, getUserDetails1 } from "../../apis/user";
import Tv from "../Tv/Tv";
import axios from "axios";
import DashedProgressBar from "../../components/dashedprogress/Dashedprogress";
import { useAudio } from "../../Providers/AudioProvider";
import { logPageView } from "../../components/analytics";
import { formatNumber } from "../../helpers/helpers";

const images = [
  {
    src: "https://d1ccopf5cw1hft.cloudfront.net/s3data/House+fly+4.svg",
    name: "Fruitfly",
  },
  {
    src: "https://d1ccopf5cw1hft.cloudfront.net/s3data/Ant+3.svg",
    name: "Ant",
  },
  {
    src: "https://d1ccopf5cw1hft.cloudfront.net/s3data/House+fly+3.svg",
    name: "Housefly",
  },
  {
    src: "https://d1ccopf5cw1hft.cloudfront.net/s3data/Gold+fish+2.svg",
    name: "Goldfish",
  },

  {
    src: "https://d1ccopf5cw1hft.cloudfront.net/s3data/Cat+3.svg",
    name: "Cat",
  },
  {
    src: "https://d1ccopf5cw1hft.cloudfront.net/s3data/Dog.svg",
    name: "Dog",
  },
  {
    src: "https://d1ccopf5cw1hft.cloudfront.net/s3data/Horse+1.svg",
    name: "Horse",
  },
  {
    src: "https://d1ccopf5cw1hft.cloudfront.net/s3data/Ostrich+3.svg",
    name: "Ostrich",
  },
  {
    src: "https://d1ccopf5cw1hft.cloudfront.net/s3data/Giant+Squid.svg",
    name: "Giant Squid",
  },
  {
    src: "https://d1ccopf5cw1hft.cloudfront.net/s3data/Collosal+Squid.svg",
    name: "Collosal Squid",
  },
];
const LeaderBoard = ({ telegramId }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const { userDetails, watchScreen, updatewatchScreenInfo, updateUserInfo } =
    useUserInfo();
  const [currentLevel, setCurrentLevel] = useState(
    userDetails.userDetails?.level
  );
  const [secs, setSecs] = useState(0);
  const [tapPoints, setTapPoints] = useState(0);
  const tapPointsRef = useRef(tapPoints);
  const [boosterPoints, setBoosterPoints] = useState(0);
  const boosterPointsRef = useRef(boosterPoints);
  const currentLevelRef = useRef(userDetails.userDetails?.level);
  const [topUsers, setTopUsers] = useState([]);
  const [userDetail, setUserDetail] = useState(null);
  const playClick = useAudio();
  useEffect(() => {
    logPageView("Leaderboard ", "LeaderBoard Page");
  }, []);
  useEffect(() => {
    // Function to fetch the leaderboard data
    const fetchLeaderboardData = async () => {
      try {
        // Replace the URL with your actual backend endpoint
        updateUserInfo((prev) => ({
          ...prev,
          isLoading: true,
        }));
        const response = await getPopularUser(
          userDetails.userDetails.telegramId
        );
        // Update the state with the data
        setTopUsers(response?.topUsers);
        setUserDetail(response?.yourDetail);
        updateUserInfo((prev) => ({
          ...prev,
          isLoading: false,
        }));
      } catch (error) {
        console.error("Error fetching leaderboard data:", error);
      }
    };
    fetchLeaderboardData();
  }, [telegramId]);
  const isEarlyUser = userDetails?.earlyUsersLimitReached ?? 
                    userDetails?.user?.earlyUsersLimitReached ?? 
                    userDetails?.userData?.earlyUsersLimitReached ?? false;
  
  // Determine which level configuration to use based on the flag
  const level = isEarlyUser ? 
    {
      1: 0,
      2: 10000,
      3: 50000,
      4: 150000,
      5: 500000,
      6: 1000000,
      7: 2500000,
      8: 5000000,
      9: 7500000,
      10: 10000000,
    } : 
    {
      1: 500,
      2: 10000,
      3: 50000,
      4: 200000,
      5: 800000,
      6: 3000000,
      7: 10000000,
      8: 25000000,
      9: 50000000,
      10: 80000000,
    };
  const goToThePage = (component, name) => {
    updateUserInfo((prev) => ({
      ...prev,
      currentComponent: component,
      currentComponentText: "TVPage",
      lastComponent: userDetails.currentComponent,
      lastComponentText: userDetails.currentComponentText,
      centerCount: userDetails.centerCount + 1,
      isMenu: false,
    }));
  };
  const handleNext = () => {
    playClick();
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    setCurrentLevel(currentLevel + 1);
  };
  const handlePrev = () => {
    playClick();
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + images.length) % images.length
    );
    setCurrentLevel(currentLevel - 1);
  };

  const scrollableRef = useRef(null);

  useEffect(() => {
    const preventTouchScroll = (event) => {
      // Allow scrolling only for the scrollable div
      if (!scrollableRef.current.contains(event.target)) {
        event.preventDefault();
      }
    };
    // Add the event listener
    document.addEventListener("touchmove", preventTouchScroll, {
      passive: false,
    });
    // Cleanup the event listener
    return () => {
      document.removeEventListener("touchmove", preventTouchScroll);
    };
  }, []);
  const getUserDetailsOnly = async () => {
    let userDetails1;
    try {
      userDetails1 = await getUserDetails1(
        userDetails?.userDetails?.telegramId
      );
    } catch (error) {
      console.error("Error in updating or fetching user details:", error);
    }
    // Update state after both async calls are completed
    if (userDetails) {
      updateUserInfo((prev) => ({
        ...prev,
        userDetails: userDetails1,
      }));
      updatewatchScreenInfo((prev) => ({
        ...prev,
        boostersList: userDetails1?.boosters,
        totalReward: userDetails1?.balanceRewards,
        tapPoints: 0,
        booster: false,
        boosterSec: 0,
        boosterPoints: 0,
        boosterDetails: {},
        watchSec: 0,
      }));
    }
    return userDetails;
  };
  const toggleMenu = () => {
    if (!watchScreen.booster) {
      const data = getUserDetailsOnly().then(() => {
        updateUserInfo((prev) => ({
          ...prev,
          isPlay: false,
          currentComponent: Tv,
          currentComponentText: "TVPage",
          lastComponent: userDetails?.userDetails.currentComponent,
          lastComponentText: userDetails?.userDetails.currentComponentText,
          isMenu: false,
          menuCount: userDetails?.userDetails?.menuCount + 1,
        }));
        // goToThePage(Battle, "BattlePage");
      });
    } else {
      goToThePage(Tv, "TVPage");
    }
    playClick();
  };
  const TotalPoints =
    Number(watchScreen.totalReward) +
    Number(secs) +
    Number(tapPoints) +
    Number(boosterPoints);
    
  return (
    <>
 
   
   <div
        className="menupointer"
        style={{
          height: "100%",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          pointerEvents: "all",
        }}
      > 
       <img
    onClick={() => {
      toggleMenu();
    }}
    src='https://d1ccopf5cw1hft.cloudfront.net/s3data/cancelicon.svg'
    className="cancel-imgleaderboard"
    style={{ cursor: "pointer",pointerEvents:'fill',zIndex:'999' }}
  />
  <div className="carousel-container">
     
     <div>
       <button
         className="carousel-button prev"
         onClick={() => {
           if (currentLevel !== 1) {
             handlePrev();
           }
         }}
       >
         <img src='https://d1ccopf5cw1hft.cloudfront.net/s3data/leftarrowBoard.png' alt="Previous" />
       </button>
       <div className="carousel-content">
         <div className="carousel-image">
           <img src={images[currentLevel - 1]?.src} alt="carousel" />
         </div>
         <div className="carousel-captions">
           {images[currentLevel - 1]?.name}
         </div>
       </div>
       <button
         className="carousel-button next"
         onClick={() => {
           if (currentLevel !== 10) {
             handleNext();
           }
         }}
       >
         <img src='https://d1ccopf5cw1hft.cloudfront.net/s3data/rightarrowBoard.png' alt="Next" />
       </button>
       <div className="col-12">
         <div className="level-h2 text-center ">
           {currentLevel === 10 ? null : (
             <h2 className="level">
               Level {currentLevel} &nbsp;
               {formatNumber(TotalPoints)}/
               {formatNumber(level[currentLevel + 1])}
             </h2>
           )}
           <div style={{ height: "10px", marginBottom: "10px" }}>
             {/* <ProgressBar style={{ height: "10px" }}>
               <ProgressBar
                 variant="warning"
                 now={Number(
                   ((watchScreen.totalReward +
                     secs +
                     tapPoints +
                     Number(boosterPoints)) /
                     level[currentLevel + 1]) *
                     100
                 ).toFixed()}
                 key={1}
               />
             </ProgressBar> */}

             <DashedProgressBar
               dashcolor={"lightgreen"}
               lengthColor={"lightgreen"}
               progress={
                 TotalPoints >= 80000000
                   ? 100
                   : Number(
                       ((watchScreen.totalReward +
                         secs +
                         tapPoints +
                         Number(boosterPoints)) /
                         level[currentLevel + 1]) *
                         100
                     ).toFixed()
               }
             />
           </div>
         </div>
       </div>
       <div className="col-12">
         <h3 className="leaderboard-text">LEADERBOARD</h3>
         <div className="cheap-stuff-container" ref={scrollableRef}>
           <div className="row mt0 cheap-rank" style={{ width: "100%" }}>
             <div className="col-9 stuff-text1 leader-color">
               <h4>{userDetail?.name}</h4>
               <p className="stuff-p">
                 <img src='https://d1ccopf5cw1hft.cloudfront.net/s3data/coinlogo.png' className="w20" />
                 <span>{ Math.floor(userDetail?.balanceRewards||0)}</span>
               </p>
             </div>
             <div className="col-3">
               <div className="rankbg">
                 <h3>{userDetail?.rank}</h3>
               </div>
             </div>
           </div>
           {topUsers?.length>0? topUsers?.map((item, index) => {
             return (
               userDetail.rank !== item.rank && (
                 <div className="row cheap-stuff1" style={{ width: "100%" }}>
                   <div className="col-9 stuff-text1 leader-color">
                     <h4>{item?.name}</h4>
                     <p className="stuff-p">
                       <img src='https://d1ccopf5cw1hft.cloudfront.net/s3data/coinlogo.png' className="w20" />{" "}
                       <span>{Math.floor(item?.balanceRewards||0)} </span>
                     </p>
                   </div>
                   <div className="col-3 rankbg">
                     <h3>{item?.rank}</h3>
                   </div>
                 </div>
               )
             );
           }):"No Records found"}
         </div>
       </div>
     </div>
   </div>
   </div>
    </>
    
    
  );
};
export default LeaderBoard;
